 const saveQueryParam = (key) => {
    const params = new URLSearchParams(window.location.search);
    const param = params.get(key);
    if (param) {
        localStorage.setItem(key, param);
        params.delete(key);
        const newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
        window.history.replaceState({}, '', newUrl);
    }
};

saveQueryParam('amoid');
saveQueryParam('utm_source');
saveQueryParam('utm_campaign');
saveQueryParam('utm_medium');
